import React from 'react';
import { motion } from 'framer-motion';
interface HeroProps {
  onBookClick: () => void;
}
export function Hero({
  onBookClick
}: HeroProps) {
  const words = ['Crafted', 'Precision.'];
  return <section className="relative w-full h-screen flex items-center justify-center overflow-hidden" data-id="element-121">
      {/* Animated gradient background */}
      <motion.div className="absolute inset-0 bg-gradient-to-br from-matte-black via-deep-green/20 to-matte-black" animate={{
      backgroundPosition: ['0% 0%', '100% 100%']
    }} transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse'
    }} style={{
      backgroundSize: '200% 200%'
    }} data-id="element-122" />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-matte-black/60" data-id="element-123" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl" data-id="element-124">
        <motion.div className="font-playfair text-6xl md:text-8xl lg:text-9xl font-bold text-off-white mb-6 tracking-wide" initial="hidden" animate="visible" data-id="element-125">
          {words.map((word, index) => <motion.span key={index} className="inline-block mr-6" variants={{
          hidden: {
            opacity: 0,
            y: 50
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.8,
          delay: index * 0.3,
          ease: 'easeOut'
        }} data-id="element-126">
              {word}
            </motion.span>)}
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="font-inter text-xl md:text-2xl text-off-white/80 mb-12 tracking-wide" data-id="element-127">
          Haircuts designed to elevate your image.
        </motion.p>

        <motion.button onClick={onBookClick} initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 1.2
      }} whileHover={{
        scale: 1.1,
        boxShadow: '0 0 40px rgba(212,175,55,0.6)'
      }} whileTap={{
        scale: 0.95
      }} className="bg-soft-gold text-matte-black px-12 py-4 rounded-full font-inter font-bold text-lg shadow-[0_0_20px_rgba(212,175,55,0.3)] transition-all" data-id="element-128">
          Book Appointment
        </motion.button>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-12 left-1/2 transform -translate-x-1/2" data-id="element-129">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className="w-6 h-10 border-2 border-off-white/30 rounded-full flex items-start justify-center p-2" data-id="element-130">
          <motion.div className="w-1 h-2 bg-off-white/50 rounded-full" data-id="element-131" />
        </motion.div>
      </motion.div>
    </section>;
}